import { FC, ReactNode } from 'react';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';

interface UrlQueryStateProviderProps {
    children: ReactNode;
}

/** Keeps nuqs query state synchronized with React Router navigation and links. */
const UrlQueryStateProvider: FC<UrlQueryStateProviderProps> = ({ children }) => (
    <NuqsAdapter>{children}</NuqsAdapter>
);

export default UrlQueryStateProvider;

